module.exports = __webpack_public_path__ + "img/15.affe9000.jpeg";